import store from './store';

function can(permission) {

  let user = store.getters['user/user'];
  let subscription = store.getters['user/subscription'];

  let pass = false;

  if (permission === 'access-health-data-scorecard') {
    // Anyone can access the health assessment or the scorecard
    return true;
  }

  const userHasSubscription = user && (user.has_app_store_subscription || user.subscription);

  if (user) {
    switch (permission) {

    case 'access-scorecard-details':
      pass = user.type == 'individual' && userHasSubscription;
      break;

    case 'access-subscriptions':
      pass = user.type == 'free' || user.type == 'individual' || user.type == 'food_service_limited' || user.type == 'food_service_full';
      break;

    case 'access-food-service-resources':
      pass = (user.type == 'food_service_limited' || user.type == 'food_service_full')  && userHasSubscription;
      break;

    case 'access-instructor-resources':
      pass = user.type == 'professional';
      break;

    case 'access-food-search':
      // pass = user.type == 'individual' && userHasSubscription;
      pass = true;
      break;

    case 'access-food-database':
    case 'access-individual-resources':
    case 'access-food-tracker':
    case 'access-communications':
    case 'access-share-portal':
      pass = (user.type == 'individual' && userHasSubscription) || user.type == 'free';
      break;

    default:
      pass = false;
      break;
    }
  }

  return pass;
}

export default {
  can: can
}
